// Configurações da conta.
//
// A ordem das seções segue o uso, não a arquitetura: assinatura e resposta
// automática são o que se mexe com frequência; 2FA e senha, quase nunca.

import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { caixas } from "../api/admin";
import { useCaixa } from "../sessao/contexto";
import { Icone } from "../ui/Icone";
import { Arquivos } from "./Arquivos";
import { Assinatura } from "./Assinatura";
import { DoisFatores } from "./DoisFatores";
import { Ferias } from "./Ferias";
import { Filtros } from "./Filtros";
import { Senha } from "./Senha";
import { ProvedorDeNaoSalvo, useNaoSalvos } from "./naoSalvo";
import { SenhasApp } from "./SenhasApp";
import { Sessoes } from "./Sessoes";

export function Conta() {
  return (
    // O registro de pendências envolve as seções, e o aviso fica ACIMA
    // delas: ver conta/naoSalvo.tsx para o porquê de avisar em vez de salvar
    // sozinho.
    <ProvedorDeNaoSalvo>
      <Miolo />
    </ProvedorDeNaoSalvo>
  );
}

function Miolo() {
  const eu = useCaixa();
  const naoSalvos = useNaoSalvos();

  // A própria caixa, para o uuid (a troca de senha precisa dele) e para saber
  // se o 2FA está ativo. A API filtra pelo escopo: um usuário comum recebe
  // exatamente uma caixa, a dele.
  const minha = useQuery({
    queryKey: ["conta", "caixa"],
    queryFn: () => caixas.listar({ q: eu.caixa }),
  });
  const caixa = minha.data?.itens?.find((c) => c.email === eu.caixa);

  return (
    <div className="flex-1 overflow-y-auto bg-fundo">
      <div className="mx-auto max-w-3xl px-6 py-8">
        <header className="mb-6 flex items-center gap-3">
          {/* A SAÍDA PERGUNTA, quando há o que perder.
              É a única saída que esta tela controla — fechar a aba é o
              navegador que avisa, pelo `beforeunload`. Sem a pergunta aqui,
              voltar ao correio com uma seção aberta descartava em silêncio
              o que estava digitado, e é isto que o apontamento 14 descreve.
              `confirm()` e não um diálogo próprio: o que se quer é
              interromper, e o nativo é o único que bloqueia a navegação do
              `<Link>` de forma síncrona. */}
          <Link
            to="/correio/INBOX"
            className="rounded-full p-2 hover:bg-linha"
            aria-label="Voltar ao correio"
            onClick={(e) => {
              if (naoSalvos.length === 0) return;
              const quais = naoSalvos.join(", ");
              if (
                !window.confirm(
                  `Você mexeu em ${quais} e ainda não salvou. ` +
                    `Sair agora descarta essas alterações.`,
                )
              ) {
                e.preventDefault();
              }
            }}
          >
            <Icone nome="RotateCcw" tamanho={18} />
          </Link>
          <div>
            <h1 className="text-xl font-semibold text-tinta">Configurações da conta</h1>
            <p className="text-sm text-tinta-fraca">{eu.caixa}</p>
          </div>
        </header>

        {/* A FAIXA DIZ QUAIS SEÇÕES, não "há alterações não salvas".
            Esta tela tem oito seções e rola: um aviso genérico obrigaria a
            percorrer todas procurando o botão que falta apertar. */}
        {naoSalvos.length > 0 && (
          <div
            role="status"
            className="mb-4 flex items-start gap-2 rounded-xl border border-aviso bg-aviso/10 px-4 py-3 text-sm text-tinta"
          >
            <Icone nome="AlertTriangle" tamanho={16} className="mt-0.5 flex-shrink-0 text-aviso" />
            <span>
              <strong>
                {naoSalvos.length === 1
                  ? "Uma seção tem alteração não salva"
                  : `${naoSalvos.length} seções têm alterações não salvas`}
                :
              </strong>{" "}
              {naoSalvos.join(", ")}. Cada uma tem o próprio botão Salvar —
              sair sem apertá-lo descarta o que você escreveu.
            </span>
          </div>
        )}

        <div className="grid gap-4">
          <Assinatura />
          <Ferias />
          <Filtros />
          <DoisFatores ativo={!!caixa?.dois_fatores} />
          <Arquivos />
          <SenhasApp />
          <Sessoes />
          {caixa?.uuid && <Senha caixaUUID={caixa.uuid} />}

        </div>
      </div>
    </div>
  );
}
